import http from '../../../http-common';

export default function requestLoadGpsall() {
    return http.get('/gps');
}
